import React, {useEffect, useState} from 'react';

import { Map } from 'components/Map/Map';

//props: {utilityPageState: boolean}
export function Footer(props: { utilityPageState: boolean, footerHidden?: boolean }) {
    const [isMapOpen, setMap] = useState(false);
    const ifUtilityFooter = props.utilityPageState ? 'utilityPage' : '';
    useEffect(() => {
        if (isMapOpen) {
            const featuresElement = document.getElementById("station-features");
            if (featuresElement) featuresElement.scrollIntoView({behavior: "smooth"});
        }
    }, [isMapOpen]);

    if (props.footerHidden) {
        return null;
    }

    return (
        <>
            <footer className={ifUtilityFooter}>
                <div className='footer__illustration' />
                <div className="footer__container">
                    <div className={'d-none d-md-flex flex-column col-md ' + (props.utilityPageState ? 'text-primary': 'text-white')}>
                        <span>AS Terminal</span>
                        <span>tel + 372 17 999</span>
                        <span>Kärkna, Tartu vald, 60513, Tartumaa</span>
                        <a
                            className={props.utilityPageState ? 'text-primary': 'text-white'}
                            href='mailto:info@terminalenergia.ee'>
                            info@terminalenergia.ee
                        </a>
                    </div>
                    <div className='col d-flex align-items-center justify-content-around'>
                        <button
                            type='button'
                            className={'d-flex align-items-center btn btn-sm text-light ' + (props.utilityPageState ? 'btn-primary': 'btn-outline-light')}
                            onClick={() => setMap(!isMapOpen)}
                        >
                            <i className={'mr-3 ' + props.utilityPageState ? 'icon__logo--masked': 'icon__logo'} />
                            <span>Leia tankla</span>
                        </button>
                        {/* <button
                            type='button'
                            className={'d-flex align-items-center btn ' + (props.utilityPageState ? 'btn-light text-primary': 'btn-primary text-light')}
                        >
                            <i className={props.utilityPageState ? 'icon__contact-us': 'icon__contact-us--masked'} />
                            <span className='ml-3 d-none d-md-inline'>Kirjuta meile</span>
                        </button> */}
                        {/*<button*/}
                        {/*    type='button'*/}
                        {/*    className={'d-flex align-items-center d-md-none  btn ' + (props.utilityPageState ? 'btn-light text-primary': 'btn-primary text-light')}*/}
                        {/*>*/}
                        {/*    <i className={'d-flex icon--24 ' + (props.utilityPageState ? 'icon__info': 'icon__info--masked')} />*/}
                        {/*</button>*/}
                    </div>
                    <div className='d-none d-xl-block col-xl'/>
                </div>
                <svg
                    className={isMapOpen ? 'bottom__decoration' : 'd-none'}
                    viewBox='0 0 1460 21'>
                    <path
                        d='M0,0 V10 H730 Q 1200, 10 1460,21 V0 Z '
                        stroke='#008C9A'
                        strokeWidth='2'
                        fill='#008C9A'
                    />
                </svg>
            </footer>
            <Map isOpen={isMapOpen} mapAction={() => setMap(!isMapOpen)} />
        </>
    )
}
